import React, { useState, useEffect } from 'react';
import { Grid, Paper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import OpportunityDtls from "./OpportunityDtls";
import OpportunityViewHeader from "./OpportunityViewHeader";
import RelatedData from "./RelatedData";
import UseFetchData from "../../../hooks/UseFetchData";

const OpportunityView = () => {
  const classes = useStyles();
  const [OpportunityMainData, setOpportunityMainData] = useState([]);
  const [OpportunityDtlsData, setOpportunityDtlsData] = useState([]);
  const [OpportunityNoteData, setOpportunityNoteData] = useState([]);
  const [OpportunityAttachData, setOpportunityAttachData] = useState([]);
  const [OpportunityImageData, setOpportunityImageData] = useState([]);
  const [OpportunityActivityData, setOpportunityActivityData] = useState([]);
  const [AccountID, setAccountID] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [ProductCount, setProductCount] = useState(0);
  const location = useLocation();
  const [responseViewDtls, fetchViewDtls] = UseFetchData();

  const getViewDtlsData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityID", location.state.OpportunityID);
    fetchViewDtls("Opportunity/View", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
      setOpportunityMainData(responseViewDtls.Main);
      setAccountID(responseViewDtls.Main[0].AccountID);
      setAccountName(responseViewDtls.Main[0].AccountName);
    }
    if (responseViewDtls.OpportunityDtls !== undefined && responseViewDtls.OpportunityDtls.length > 0) {
      setOpportunityDtlsData(responseViewDtls.OpportunityDtls);
      setProductCount(responseViewDtls.OpportunityDtls.length);
    }
    if (responseViewDtls.OpportunityActivity !== undefined && responseViewDtls.OpportunityActivity.length > 0) {
      setOpportunityActivityData(responseViewDtls.OpportunityActivity);
    }
    if (responseViewDtls.OpportunityNotes !== undefined && responseViewDtls.OpportunityNotes.length > 0) {
      setOpportunityNoteData(responseViewDtls.OpportunityNotes);
    }
    if (responseViewDtls.OpportunityAttachments !== undefined && responseViewDtls.OpportunityAttachments.length > 0) {
      setOpportunityAttachData(responseViewDtls.OpportunityAttachments);
    }
    if (responseViewDtls.OpportunityImage !== undefined && responseViewDtls.OpportunityImage.length > 0) {
      setOpportunityImageData(responseViewDtls.OpportunityImage);
    }
  }, [responseViewDtls]);

  useEffect(() => {
    getViewDtlsData();
  }, [])

  return (
    <Paper>
      <OpportunityViewHeader
        OpportunityID={location.state.OpportunityID}
        OpportunityMainData={OpportunityMainData}
        PopulateData={getViewDtlsData}
        ProductCount={ProductCount}
        setProductCount={setProductCount}
      />
      <Grid container direction="row" className={classes.container}>
        <Grid sm={8} xs={12}>
          <Paper elevation={3} style={{ height: '100%' }}>
            <OpportunityDtls
              OpportunityID={location.state.OpportunityID}
              OpportunityMainData={OpportunityMainData}
              OpportunityDtlsData={OpportunityDtlsData}
              PopulateData={getViewDtlsData}
              ProductCount={ProductCount}
              setProductCount={setProductCount}
            />
          </Paper>
        </Grid>
        <Grid sm={4} xs={12}>
          <Paper elevation={3} >
            <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5, paddingLeft: 10 }}>RELATED</h2>
            <RelatedData
              OpportunityID={location.state.OpportunityID}
              OpportunityMainData={OpportunityMainData}
              OpportunityNoteData={OpportunityNoteData}
              OpportunityAttachData={OpportunityAttachData}
              OpportunityImageData={OpportunityImageData}
              OpportunityActivityData={OpportunityActivityData}
              ACID={AccountID}
              ACName={AccountName}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 7,
  },


}));

export default OpportunityView;
